var cibZendesk = ["32 32", "<path d='M14.781 28.125h-14.781l14.781-17.844zM32 28.125h-14.781c0-4.084 3.308-7.391 7.391-7.391 4.084 0 7.391 3.312 7.391 7.391zM17.219 21.719v-17.844h14.781zM14.781 3.875c0 4.079-3.308 7.391-7.391 7.391-4.084 0-7.391-3.307-7.391-7.391z'/>"];

export { cibZendesk };

